export default "__VITE_ASSET__BiGbfkfu__"